import { ReactNode, useState } from 'react'
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from '@headlessui/react'
import { cn } from '../utilities.ts'

interface PopoverProps {
  children: ReactNode
  message: string
  className?: string
}

const InformationPopover = ({ children, message, className }: PopoverProps) => {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <Popover className="relative inline-block">
      <PopoverButton
        className="cursor-default"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        {children}
      </PopoverButton>
      <Transition show={isHovering}>
        <PopoverPanel
          className={cn(
            className,
            'absolute z-10 w-auto px-4 mt-2 left-1/2 transform -translate-x-1/2 bottom-full'
          )}
        >
          <div className="w-auto max-w-md min-w-32 flex-auto overflow-hidden rounded-xl bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5">
            <div className="p-4">{message}</div>
          </div>
        </PopoverPanel>
      </Transition>
    </Popover>
  )
}

export default InformationPopover
